import { api } from "@services/baseURL";

export const UpdateItensSelecionados = async (idSolicitacao, payload) => {
    try {
        const response = await api.patch(`SolicitacaoProcessoItem/update-flag-item/${idSolicitacao}`, payload);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar o item da solicitação:', error);
        throw error;
    }
};

export const UpdateObservacoesItemProcesso = async (idSolicitacaoProcessoItem, payload) => {
    try {
        const response = await api.patch(`SolicitacaoProcessoItem/update-observacoes-item/${idSolicitacaoProcessoItem}`, payload);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar a observação do item do processo:', error);
        throw error;
    }
};

export default {
    UpdateItensSelecionados,
    UpdateObservacoesItemProcesso,
};